<template>
   <v-container class="login-container bg-dot-img  align-self-center">
      <v-row >
       <v-col offset-lg="3">
        <AdminLoginComponent />
      </v-col>
    </v-row>
  </v-container>
 </template>
 <script>
  import AdminLoginComponent from '../Admin/AdminLoginComponent.vue';
   export default {
  components: {
       AdminLoginComponent,
      },
  data: () => ({
  
  }),
  methods: {
  }
};
</script>